import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AppLogger } from '@/lib/logger';

const log = AppLogger.getLogger(import.meta);
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { AddDeviceTypeComposer } from "@/forms/sensory";
import { Plus } from "lucide-react";

interface AddDeviceTypeButtonProps {
  onSuccess?: () => void;
}

export function AddDeviceTypeButton({ onSuccess }: AddDeviceTypeButtonProps) {
  const [open, setOpen] = useState(false);

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  const handleError = (error: Error) => {
    log.error("Failed to create device type:", error);
    alert(`Failed to create device type: ${error.message}`);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" className="gap-2">
          <Plus className="h-4 w-4" />
          Add Device Type
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add New Device Type</DialogTitle>
        </DialogHeader>
        <AddDeviceTypeComposer
          onSuccess={handleSuccess}
          onError={handleError}
          onCancel={() => setOpen(false)}
          showHeader={false}
        />
      </DialogContent>
    </Dialog>
  );
}
